import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { CustomerInfo } from './components/CustomerInfo';
import { CustomerHistory } from './components/CustomerHistory';

const TABS = {
  INFO: 1,
  HISTORY: 2
};

const TAB_CONFIG = [
  { id: TABS.INFO, label: 'ข้อมูลลูกค้า', component: CustomerInfo },
  { id: TABS.HISTORY, label: 'ประวัติการซื้อ', component: CustomerHistory }
];

export function CustomerForm() {
  const [activeTab, setActiveTab] = useState(TABS.INFO);

  const renderTabButton = ({ id, label }) => (
    <Button
      key={id}
      type="button"
      className={`btn-category px-4 ${activeTab === id ? 'active' : ''}`}
      onClick={() => setActiveTab(id)}
    >
      {label}
    </Button>
  );

  const ActiveComponent = TAB_CONFIG.find(tab => tab.id === activeTab)?.component || CustomerInfo;

  return (
    <>
      <nav aria-label="breadcrumb" className="mt-2">
        <ol className="breadcrumb fs-16 ps-0">
          <li className="breadcrumb-item">
            <a href="#" className="tc-7 text-decoration-none">
              สมาชิก/ลูกค้า
            </a>
          </li>
          <li className="breadcrumb-item active tc-1" aria-current="page">
            รายชื่อลูกค้า
          </li>
        </ol>
      </nav>

      <div className="mb-3">{TAB_CONFIG.map(renderTabButton)}</div>

      <ActiveComponent />
    </>
  );
}
